import type { JSX } from 'react';

import { cn } from '@change/ds-utils';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { PetitionStats } from './components/PetitionStats';
import { PetitionStrengthScore } from './components/PetitionStrengthScore';
import { ReachedYourGoal } from './components/ReachedYourGoal';
import { usePetitionOverview } from './hooks/usePetitionOverview';

export function PetitionOverview(): JSX.Element {
	const {
		data: { strengthTipsEnabled },
	} = usePetitionOverview();

	return (
		<section className="bg-white px-4 py-8 lg:p-12" aria-labelledby="petition-overview-title" role="group">
			<div className="mb-6 flex items-center justify-between">
				<Text
					className="text-size-heading-xs md:text-size-heading-small"
					size="small"
					as="h2"
					variant="heading"
					id="petition-overview-title"
					data-qa="petition-overview-title"
					data-testid="petition-overview-title"
				>
					<Translate value="corgi.petition.starter_dashboard.petition_overview.title" />
				</Text>
			</div>
			<div
				className={cn('grid grid-cols-[1fr] grid-rows-[auto_1fr] border-[unset]', {
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'lg:grid-cols-[2fr_1fr]': strengthTipsEnabled,
				})}
			>
				<div className="relative">
					<PetitionStats />
				</div>
				{strengthTipsEnabled && <PetitionStrengthScore />}
				<div className="col-[1_/_-1]">
					<ReachedYourGoal />
				</div>
			</div>
		</section>
	);
}
